import { Box as DarkBox, Toggle } from '@hivewatch/dark'

import { darkFloorsPanelStyles } from './DarkFloorsPanel.styles'

interface DarkFloorListToggleIProps {
  checked: boolean
  colorScheme: 'dark' | 'light'
  label: string
  onToggle: () => void
  dataTestId?: string
}

// Dark Toggle has no visible label of its own, so the label is composed next
// to it — prior art: incident-drawer ResolveToggle.
export const DarkFloorListToggle = ({
  checked,
  colorScheme,
  label,
  onToggle,
  dataTestId = 'floorPlanPage_floorsPanel_filterToggle',
}: DarkFloorListToggleIProps) => {
  const s = darkFloorsPanelStyles(colorScheme)

  return (
    <DarkBox {...s.toggleRow}>
      <Toggle
        aria-label={label}
        colorScheme={colorScheme}
        data-testid={dataTestId}
        isOn={checked}
        onChange={onToggle}
      />
      <DarkBox as='span' {...s.toggleLabel}>
        {label}
      </DarkBox>
    </DarkBox>
  )
}
